<div class="border bg-light cat-info ">
    <div class="" (click)="goToCategoriesPage(cat.id)">
        <img src="{{getImageURL()}}" class="img-fluid" alt="{{cat.name}}">
    </div>
    <div style="color: #323232;    font-size: 14px;" class="text-left cat-details" (click)="goToCategoriesPage(cat.id)">{{(cat.name.length>30)? (cat.name | slice:0:30)+'..':(cat.name)}}</div>
</div>

<div class="cat-info p-3 border bg-light hide">
    <p style="text-align: center" *ngFor="let catDet of CategoriesDet">{{(catDet.name.length>6)? (catDet.name | slice:0:6)+'..':(catDet.name)}} </p>
</div>
